import React, { useState, useEffect } from "react";
import eyeIcon from "../../asessts/Images/eye_icon.svg";
import emptyIllustration from "../../asessts/Images/empty_illustration.jpg";
import { useDispatch, useSelector } from "react-redux";
import Loading from "../../components/loader/Loading";
import { useLocation, useNavigate } from "react-router-dom";
import client from "../../services/Client";
import { setCurrentPage } from "../../redux/slices/currentPageSlice";
import { Link } from "react-router-dom";
import Pagination from "../../components/common/Pagination";

const Scientist = () => {
  const [posts, setPosts] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [total, setTotal] = useState("");
  const [perPage] = useState(10);
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const currentPage = useSelector(
    (state) => state.currentPageSlice.currentPage
  );

  const fetchFitness = async (page = currentPage) => {
    try {
      setIsLoading(true);
      const response = await client.get(
        `/admin/healthProfessional/get-medicalLabScientists?page=${page}`
      );
      setPosts(response.data.data.medicalLabScientistRes);
      setTotal(response.data.data.total);
      dispatch(setCurrentPage(response.data.response.currentPage));
      setIsLoading(false);
    } catch (error) {
      console.log("Error while fetching posts", error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchFitness(currentPage);
  }, [location]);

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= Math.ceil(total / perPage)) {
      dispatch(setCurrentPage(newPage));
      const queryParams = new URLSearchParams(location.search);
      const activeTab = queryParams.get("tab") || "Hospital";

      navigate(`/professional?page=${newPage}&tab=${activeTab}`);
    }
  };

  return (
    <div class="table-data-main">
      {isLoading ? (
        <Loading />
      ) : posts.length === 0 ? (
        <div style={{ textAlign: "center", padding: "40px 20px" }}>
          <img
            src={emptyIllustration}
            alt="No lab scientists found"
            style={{ maxWidth: "400px", width: "100%", height: "auto" }}
          />
          <p style={{ marginTop: "20px", fontSize: "16px", color: "#666" }}>
            No data found
          </p>
        </div>
      ) : (
        <>
          <div class="table-data">
            <table border="0" cellpadding="0" style={{ width: "100%" }}>
              <thead
                style={{
                  backgroundColor: "#FDFDFD",
                  borderBottom: "1px solid #EDEDED",
                }}
              >
                <tr>
                  <th class="heading">Profile ID</th>
                  <th class="heading">Name</th>
                  <th class="heading">Department</th>
                  <th class="heading">Email</th>
                  <th class="heading">Phone Number</th>
                  <th class="heading" style={{ width: "7%" }}>
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {posts.map((post, index) => (
                  <tr key={index} style={{ borderBottom: "1px solid #EDEDED" }}>
                    <td class="table-col">
                      <table>
                        <tr>
                          <td className="rating" style={{ border: "none" }}>
                            {post.profileId ? post.profileId : "--"}
                          </td>
                        </tr>
                      </table>
                    </td>
                    <td class="table-col">
                      {post.firstName} {post.lastName}
                    </td>
                    <td class="table-col">{post.department}</td>
                    <td class="table-col">{post.email}</td>

                    <td class="table-col">
                      {post?.phoneNumber?.number
                        ? `+${post.phoneNumber.dialCode} ${post.phoneNumber.number}`
                        : ""}
                    </td>
                    <td style={{ textAlign: "center" }} class="table-col">
                      <Link to={`/professional-detail-scientist/${post.id}`}>
                        <img src={eyeIcon} alt="" />
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <Pagination
            currentPage={currentPage}
            total={total}
            perPage={perPage}
            onPageChange={handlePageChange}
          />
        </>
      )}
    </div>
  );
};

export default Scientist;
